import { render } from "./HoxtonAlterWallComponent.vue?vue&type=template&id=47011942&scoped=true"
import script from "./HoxtonAlterWallComponent.vue?vue&type=script&lang=js"
export * from "./HoxtonAlterWallComponent.vue?vue&type=script&lang=js"

import "./HoxtonAlterWallComponent.vue?vue&type=style&index=0&id=47011942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47011942"]])

export default __exports__